module.exports = __webpack_public_path__ + "static/assets/epic-championship-series.a62e23b.png";